<template>
  <b-carousel
    class="carousel"
    indicators
    label-goto-slide="Chod na slide"
  >
    <b-carousel-slide 
        v-for="image in activeSliderImages" :key="'carousel-image' + image.image" 
        :img-src="image.image" 
        :caption="image.title"
        :text-html="image.text"
     />
  </b-carousel>
</template>

<script>
import { mapGetters } from "vuex";
import { BCarousel, BCarouselSlide } from 'bootstrap-vue'

export default {
  computed: {
    ...mapGetters(["activeSliderImages"])
  },
  components: {
    BCarousel,
    BCarouselSlide,
  }
};
</script>
